var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_484_686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1878 7.85755L7.50031 12.5L2.81281 7.85755C2.50363 7.55668 2.26009 7.19506 2.09753 6.79545C1.93497 6.39584 1.85691 5.96689 1.86827 5.53563C1.87963 5.10437 1.98016 4.68013 2.16353 4.28963C2.34691 3.89914 2.60914 3.55083 2.93374 3.26666C3.25833 2.98249 3.63825 2.76861 4.04957 2.63848C4.46088 2.50835 4.89469 2.46479 5.32367 2.51055C5.75264 2.55631 6.1675 2.6904 6.54211 2.90437C6.91672 3.11833 7.24297 3.40755 7.50031 3.7538C7.75877 3.41006 8.0854 3.12337 8.45975 2.91168C8.8341 2.69998 9.24812 2.56783 9.67589 2.5235C10.1037 2.47917 10.536 2.52361 10.9458 2.65404C11.3556 2.78448 11.7341 2.9981 12.0575 3.28153C12.381 3.56496 12.6425 3.9121 12.8256 4.30123C13.0087 4.69036 13.1095 5.1131 13.1218 5.54299C13.134 5.97288 13.0573 6.40067 12.8966 6.79958C12.7359 7.19849 12.4946 7.55994 12.1878 7.8613",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1878 7.85755L7.50031 12.5L2.81281 7.85755C2.50363 7.55668 2.26009 7.19506 2.09753 6.79545C1.93497 6.39584 1.85691 5.96689 1.86827 5.53563C1.87963 5.10437 1.98016 4.68013 2.16353 4.28963C2.34691 3.89914 2.60914 3.55083 2.93374 3.26666C3.25833 2.98249 3.63825 2.76861 4.04957 2.63848C4.46088 2.50835 4.89469 2.46479 5.32367 2.51055C5.75264 2.55631 6.1675 2.6904 6.54211 2.90437C6.91672 3.11833 7.24297 3.40755 7.50031 3.7538C7.75877 3.41006 8.0854 3.12337 8.45975 2.91168C8.8341 2.69998 9.24812 2.56783 9.67589 2.5235C10.1037 2.47917 10.536 2.52361 10.9458 2.65404C11.3556 2.78448 11.7341 2.9981 12.0575 3.28153C12.381 3.56496 12.6425 3.9121 12.8256 4.30123C13.0087 4.69036 13.1095 5.1131 13.1218 5.54299C13.134 5.97288 13.0573 6.40067 12.8966 6.79958C12.7359 7.19849 12.4946 7.55994 12.1878 7.8613",
    stroke: "#707070",
    strokeWidth: 0.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_484_686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.3de1d91fa2e18848781f270d8ad6d1a5.svg";
export { ForwardRef as ReactComponent };